import advanceReportingStore from "@/store/modules/AdvanceReporting/advanceReportingStore"

const advanceReportingModules = {
  advanceReportingStore
}

export default advanceReportingModules
